import classNames from 'classnames'

type FilterButtonClassKey = 'filterButton' | 'mobileFilterButton' | 'filterButtonSecondary' | 'filterButtonPrimary'
type FilterButtonClasses = Partial<Record<FilterButtonClassKey, string>>

export function countActiveFilterFields(fields: boolean[]): number {
  return fields.filter(Boolean).length
}

export function getDesktopFilterButtonClassName(args: { classes: FilterButtonClasses; isOpen: boolean }): string {
  const { classes, isOpen } = args
  return classNames(
    classes.filterButton,
    !isOpen && classes.filterButtonSecondary,
    isOpen && classes.filterButtonPrimary
  )
}

export function getMobileFilterButtonClassName(args: { classes: FilterButtonClasses; isOpen: boolean }): string {
  const { classes, isOpen } = args
  return classNames(
    classes.filterButton,
    classes.mobileFilterButton,
    !isOpen && classes.filterButtonSecondary,
    isOpen && classes.filterButtonPrimary
  )
}
